export function StoreIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.44535 2.66608L14.8942 2.66609V12.2233H13.3942V9.16435L11.5599 9.16434V12.4479H1.10779V4.6699L4.44535 4.66988V2.66608ZM4.44535 6.16988L2.60779 6.16989V10.9479H4.44535V6.16988ZM5.94535 9.16433V10.9479H10.0599V9.16434L5.94535 9.16433ZM13.3942 7.66435V4.16609L5.94535 4.16608V7.66433L13.3942 7.66435Z"
        fill="#3643BA"
      />
    </svg>
  )
}
